import { useNavigate } from "react-router-dom";
import { EMPTY_OFFER, OfferForm, createOffer } from "./OfferForm";

export function OfferNew() {
	const nav = useNavigate();
	return (
		<div className="p-6">
			<h1 className="mb-4 text-xl font-semibold">New offer</h1>
			<OfferForm
				initial={EMPTY_OFFER}
				submitLabel="Create"
				showTemplates
				onSubmit={async (v) => {
					const { id } = await createOffer(v);
					nav(`/offers/${id}`, { replace: true });
				}}
				onCancel={() => nav("/offers")}
			/>
		</div>
	);
}
